import { useAuthContext } from 'src/hooks/auth/use-auth-context';

import { isAdmin } from 'src/services/auth/auth.utils';

/**
 * Whether the signed-in user may export records to a CSV: organisation admins and operational
 * admins, the rule the server enforces with EXPORT_RESOURCES (JT1-1913).
 */
export function useCanExport(): boolean {
  const authContext = useAuthContext();

  return Boolean(authContext?.account) && isAdmin(authContext);
}
